import React, { Component } from 'react';
import moment from 'moment';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { withStyles  } from '@mui/styles';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import { Button as ReactButton } from '@mui/material';
import { IconButton as ReactIconButton } from '@mui/material';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import {
  FilterList as FilterIcon
} from '@mui/icons-material';
import { WithTracking } from "../WithTracking";
const IconButton = WithTracking(ReactIconButton);
const Button = WithTracking(ReactButton);

const styles = theme => ({
  card: {
    width: 460,
    position: 'absolute',
    right: 50,
    overflowY: 'scroll',
    zIndex: 1000
  },
  cardHeader: {
    background: theme.palette.primary.main
  },
  divider: {
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.grey[300]
  },
  textField: {
    width: 190,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1)
  },
  white: {
    color: theme.palette.common.white
  },
  right: {
    marginLeft: 'auto'
  }
});

class Filter extends Component {

  constructor(props) {
    super(props);
    const tempFilter = props.filterCriteria.clone();
    tempFilter.notificationsEnabled = false;
    this.state = {
      filterMode: false,
      tempFilter
    };
    this.months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];
  }

  /* eslint-enable react/no-deprecated */
  toggle = () => {
    let { filterMode } = this.state;
    filterMode = !filterMode;
    this.setState({ filterMode });
    if (filterMode) {
      const tempFilter = this.props.filterCriteria.clone();
      tempFilter.notificationsEnabled = false; // do not fire events on every field change
      this.setState({ tempFilter });
    }
  };

  apply = () => {
    const { tempFilter } = this.state;
    this.props.filterCriteria.assign(tempFilter);
    this.close();
  };

  close = () => {
    this.setState({ filterMode: false });
  };

  keyDown = evt => {
    if (evt.keyCode === 13) {
      this.apply();
    }
    if (evt.keyCode === 27) {
      this.close();
    }
  };

  handleChange = evt => {
    const id = evt.target.getAttribute('id');
    this.changeFieldValue(id, evt.target.value);
  };

  handleMonthChange = id => date => {
    const d = moment(date).isValid() ? date.toISOString() : null;
    this.changeFieldValue(id, d);
  };

  handleDateChange = id => date => {
    const d = moment(date).isValid() ? date.toISOString() : null;
    this.changeFieldValue(id, d);
  };

  changeFieldValue = (id, value) => {
    const { tempFilter } = this.state;
    const f = tempFilter.find(id);
    if (f) {
      f.value = value;
    }
    this.setState({ tempFilter });
  };

  buildFilterFields = () => {
    const { classes } = this.props;
    const { tempFilter } = this.state;

    return tempFilter.fields
    .map(f => {
      if (f.isDate)
        return (
          <LocalizationProvider
            key={f.id}
            dateAdapter={AdapterMoment}
          >
            <DatePicker
              clearable
              id={f.id}
              label={f.label}
              value={f.value ? moment(f.value) : null}
              inputFormat="MM/DD/YYYY"
              margin="normal"
              className={classes.textField}
              onChange={this.handleDateChange(f.id)}
              animateYearScrolling={false}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        );
      if (f.isSynth) {
        return (
          <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            clearable
            inputFormat="MMMM yyyy"
            views={['year', 'month']}
            name={f.label}
            emptyLabel=""
            label={f.label}
            value={f.value || null}
            component="span"
            onChange={this.handleMonthChange(f.id)}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        )}
      return (
        <TextField
          variant="standard"
          name={f.label}
          id={f.id}
          key={f.id}
          label={f.label}
          margin="normal"
          className={classes.textField}
          value={f.value || ''}
          InputProps={{
            onChange: this.handleChange,
            onBlur: this.filter,
            onKeyDown: this.keyDown
          }} />
      );
    });
  };

  render() {
    const { classes } = this.props;
    const { filterMode } = this.state;
    const cardStyle = { height : window.innerHeight - 320 };

    return (
      <div>
        <Tooltip title="Filter" placement="top">
          <IconButton
            arial-label="Filter"
            onClick={this.toggle}
            tracking={{action:'Show Filter'}}
            size="large">
            <FilterIcon />
          </IconButton>
        </Tooltip>
        {filterMode && (
        <Card className={classes.card} style={cardStyle}>
          <CardHeader
            title="Filter"
            className={classes.cardHeader}
            classes={{
                title: classes.white
              }}
          />
          <CardContent className={classes.divider}>
            {this.buildFilterFields()}
          </CardContent>
          <CardActions>
            <Button
              color="secondary"
              className={classes.right}
              onClick={this.close}
              tracking={{action:'Close Filter'}}
            >
              Close
            </Button>
            <Button
              color="primary"
              className={classes.right}
              onClick={this.apply}
              tracking={{action:'Apply Filter'}}
            >
              Apply
            </Button>
          </CardActions>
        </Card>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(Filter);
